import { l10nTranslations } from './l10n/localization';
const locale = {
    de: {
        selectYear: 'Jahr wählen',
        weekDays: [
            'Sonntag',
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag',
        ],
        daysTwoLetter: [
            'So',
            'Mo',
            'Di',
            'Mi',
            'Do',
            'Fr',
            'Sa',
        ],
        months: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
        ],
        getMonthName(month) {
            return this.months[month - 1];
        },
        getWeekDayName(weekDay) {
            return this.daysTwoLetter[weekDay];
        },
        arrival: {
            possible: 'Anreise möglich',
            notPossible: 'Anreise nicht möglich',
        },
        departure: {
            possible: 'Abreise möglich',
            notPossible: 'Abreise nicht möglich',
            mionStay: 'Abreise nicht möglich, da die Mindestaufenthaltsdauer nicht erfüllt wird',
        },
        label: {
            on: 'Am',
            from: 'Ab',
        },
        overlay: {
            close: 'Fertig',
        },
    },
    it: {
        selectYear: 'Scegliere l\'anno',
        weekDays: [
            'domenica',
            'lunedì',
            'martedì',
            'mercoledì',
            'giovedì',
            'venerdì',
            'sabato',
        ],
        daysTwoLetter: [
            'do',
            'lu',
            'ma',
            'me',
            'gi',
            've',
            'sa',
        ],
        months: [
            'gennaio',
            'febbraio',
            'marzo',
            'aprile',
            'maggio',
            'giugno',
            'luglio',
            'agosto',
            'settembre',
            'ottobre',
            'novembre',
            'dicembre',
        ],
        getMonthName(month) {
            return this.months[month - 1];
        },
        getWeekDayName(weekDay) {
            return this.daysTwoLetter[weekDay];
        },
        arrival: {
            possible: 'arrivo/check-in possibile',
            notPossible: 'arrivo/check-in non possibile',
        },
        departure: {
            possible: 'partenza/check-out possibile',
            notPossible: 'partenza/check-out non possibile',
            mionStay: 'partenza/check-out non possibile, poiché non è stato raggiunto il soggiorno minimo richiesto',
        },
        label: {
            on: 'il',
            from: 'da',
        },
        overlay: {
            close: 'Chiudi',
        },
    },
    en: {
        selectYear: 'Select year',
        weekDays: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
        ],
        daysTwoLetter: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa',
        ],
        months: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ],
        getMonthName(month) {
            return this.months[month - 1];
        },
        getWeekDayName(weekDay) {
            return this.daysTwoLetter[weekDay];
        },
        arrival: {
            possible: 'Arrival possible',
            notPossible: 'Arrival not possible',
        },
        departure: {
            possible: 'Departure possible',
            notPossible: 'Departure not possible',
            mionStay: 'Departure not possible. The selected period requires a minimum stay.',
        },
        label: {
            on: 'on',
            from: 'from',
        },
        overlay: {
            close: 'Done',
        },
    },
};
export const DatePickerTranslations = l10nTranslations(locale);
